import React from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

/**
 * GraficaBarrasHorizontal — Barras horizontales centradas y responsivas.
 *
 * Props:
 *   titulo    {string}   Título opcional sobre la gráfica
 *   etiquetas {string[]} Etiquetas del eje Y
 *   datos     {Array<{ label: string, valores: number[] }>}
 *   colores   {string[]} Colores de cada dataset
 *   unidad    {string}   Unidad para mostrar en el tooltip (default: "")
 */
const GraficaBarrasHorizontal = ({
    titulo = "",
    etiquetas = [],
    datos = [],
    colores = [],
    unidad = "",
}) => {
    const data = {
        labels: etiquetas,
        datasets: datos.map((item, index) => ({
            label: item.label,
            data: item.valores,
            backgroundColor: colores[index % colores.length],
            borderRadius: 5,
            barPercentage: 0.65,
            categoryPercentage: 0.7,
        })),
    };

    const options = {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "top",
                labels: { font: { size: 12, weight: "bold" }, padding: 12 },
            },
            tooltip: {
                callbacks: {
                    label: (item) =>
                        ` ${item.dataset.label}: ${item.raw}${unidad ? " " + unidad : ""}`,
                },
            },
            datalabels: {
                display: true,
                color: "#222",
                textStrokeColor: "rgba(255,255,255,0.7)",
                textStrokeWidth: 2,
                anchor: "end",
                align: "right",
                clamp: true,
                font: { weight: "bold", size: 11 },
                formatter: (value) => (value !== 0 ? value : ""),
                clip: false,
            },
        },
        scales: {
            x: {
                beginAtZero: true,
                ticks: { font: { size: 12 }, stepSize: 1 },
                grid: { color: "rgba(0,0,0,0.06)" },
            },
            y: {
                ticks: {
                    font: { size: 11, weight: "bold" },
                    autoSkip: false,
                    maxRotation: 0,
                    minRotation: 0,
                },
                grid: { display: false },
            },
        },
        layout: { padding: { top: 4, bottom: 4, left: 4, right: 32 } },
    };

    return (
        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
            {titulo && (
                <h4 style={{ fontWeight: 700, marginBottom: 8, textAlign: "center", fontSize: 13 }}>
                    {titulo}
                </h4>
            )}
            <div style={{ width: "100%", height: "100%", minHeight: 220 }}>
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default GraficaBarrasHorizontal;